// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { Injectable } from '@angular/core';
import { AppEnvironmentService } from './app-environment.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PricingPlan } from 'src/app/model/pricingplan';
import { map } from 'rxjs';

const contentType = 'application/json';

@Injectable({
  providedIn: 'root'
})

export class PricingplanService {
  private get baseApiUrl(): string { return this.appEnvironmentService.baseApiUrl; }

  constructor(private readonly appEnvironmentService: AppEnvironmentService, private readonly http: HttpClient) { }

  createPricingPlan(pricingPlan: PricingPlan) {
    let accessToken = localStorage.getItem('access_token');
    const apiUrl = this.baseApiUrl + `tenants/${pricingPlan.tenantId}/pricingplan`;

    const headers = new HttpHeaders({
      'Content-Type': contentType,
      'Authorization': `Bearer ${accessToken}`
    });

    const httpOptions = {
      headers: headers
    }

    return this.http.post<PricingPlan>(apiUrl, pricingPlan.toCreationAPIForm(), httpOptions);
  }

  updatePricingPlan(pricingPlan: PricingPlan) {
    let accessToken = localStorage.getItem('access_token');
    const apiUrl = this.baseApiUrl + `pricingplans/${pricingPlan.id}`;

    const headers = new HttpHeaders({
      'Content-Type': contentType,
      'Authorization': `Bearer ${accessToken}`
    });

    const httpOptions = {
      headers: headers
    }

    return this.http.put<PricingPlan>(apiUrl, pricingPlan.toCreationAPIForm(), httpOptions);
  }

  getPricingPlans(tenantId: number) {
    let accessToken = localStorage.getItem('access_token');
    const apiUrl = this.baseApiUrl + `tenants/${tenantId}/pricingplans`;

    const headers = new HttpHeaders({
      'Content-Type': contentType,
      'Authorization': `Bearer ${accessToken}`
    });

    const httpOptions = {
      headers: headers
    }
    //@ts-ignore
    return this.http.get<PricingPlan[]>(apiUrl, httpOptions).pipe(map((pricingPlans) => {
      return pricingPlans.map((pricingPlan) => PricingPlan.FromRaw(pricingPlan))
    }));
  }

  deletePricingPlan(pricingPlanId: number) {
    let accessToken = localStorage.getItem('access_token');
    const apiUrl = `${this.baseApiUrl}pricingplans/${pricingPlanId}`;

    const headers = new HttpHeaders({
      'Content-Type': contentType,
      'Authorization': `Bearer ${accessToken}`
    });

    const httpOptions = {
      headers: headers
    }

    return this.http.delete<void>(apiUrl, httpOptions);
  }
}
